import { KeyValue } from "../models/PaymentOptions"

const paymentOptions: Array<KeyValue> = [
    {
      "name": "Cargo Sprint",
      "value": "Cargo Sprint"
    },
    {
      "name": "Pay Cargo",
      "value": "Pay Cargo"
    },
    {
      "name": "Cheque",
      "value": "Cheque"
    },
    {
      "name": "Cash",
      "value": "Cash"
    },
    {
      "name": "Other",
      "value": "other"
    }
]

export { paymentOptions }